/*
 * Because backend sends a string, we need to parse it and extract the date object so that
 * angular date formatter can localize the string.
 * This can be removed when backend sends proper timestamps instead of self defined strings.
 */
angular.module('cfn').filter('fix_parseBackendDate', function() {
  return function(dateString) {
    return Date.parse(dateString) || dateString;
  };
});
